// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select, DatePicker, Input, Tabs, Button } from "antd";
import moment from "moment";
import { Avatar } from "antd";
import DefaultImage from "../../assets/img/userDefault.png";
import { Down } from "@icon-park/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Breadcrumb from 'BidGrid/components/BidBreadCrumb/Breadcrumb';
import { useLocation, useParams } from "react-router";
// import { ProfileDetails } from 'Services/Profile/ProfileDetails';
import { useSelector } from "react-redux";
// import { userDetailsApi } from 'Services/bidgrid/master/profile/bidProfile';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { AddTenderList } from 'Services/bidgrid/add/AddTender';
import dayjs from "dayjs";
import PasswordChange from "../Profile/PasswordChange";
import Header from "../../components/Includes//Header";
import { useFetch } from "../../Services/useFetch";
import { Padding } from "@mui/icons-material";
import { DocImgBaseUrl } from "../../utils/configurable";
import { fetchAuthMode } from "../../utils/docGridSso";
const { TextArea } = Input;
const intialState = {
  // profileImg: "",
  firstname: "",
  lastname: "",
  company_id: null,
  email: "",
  contactnumber: "",
  password: "",
  country_id: null,
  state_id: null,
  city_id: null,
  date_of_birth: null,
  full_address_1: "",
  zip_code: "",
  old_password: "",
  module_id: null,
  confirmPassword: "",
};

const EMPLOYEEUpdateProfile = () => {
  const [form] = Form.useForm();
  // idp mode: name, email and phone come from HRMS, and passwords live only
  // in the company login.
  const [isIdpMode, setIsIdpMode] = useState(false);

  useEffect(() => {
    fetchAuthMode().then((mode) => setIsIdpMode(mode === "idp"));
  }, []);
  // const [image, setImage] = useState(null);
  const [userName, setUserName] = useState([]);
  const [skeleton, setSkeleton] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [personalInputData, setPersonalInputData] = useState(intialState);
  const [profileCountry, setProfileCountry] = useState([]);

    const [selectedModuleId, setSelectedModuleId] = useState([4, 2]); // Pre-selected values

  const [profileState, setProfileState] = useState([]);
  const [profileCity, setProfileCity] = useState([]);
  const [module, setModule] = useState([]);

  const { request } = useFetch();
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const { id } = useParams();

  const BdUserdetails = async () => {
    const formData = new URLSearchParams();
    formData.append("user_id", id);
    try {
      const response = await request("/user-details-edit", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        setUserName(response.data.data);
        // await empDropdownValues()
        const dataVal = response?.data?.data;
        const newObj = {
          // profileImg: userName?.profileimg || '',
          firstname: dataVal?.firstname || "",
          lastname: dataVal?.lastname || "",
          role_id: dataVal?.emp_role_id || "",
          company_id: dataVal?.company_id || "",
          department_id: dataVal?.department_id || "",
          designation_id: dataVal?.designation_id || "",
          module: dataVal?.user_permissions?.map((perm) => (perm.module_id)) || [],
          jobgrade_id: dataVal?.jobgrade_id || "",
          reporting_mngr_id: dataVal?.reporting_mngr_id || "",
          email: dataVal?.email || "",
          contactnumber: dataVal?.contactnumber || "",
          unit_id: dataVal?.unit_id || "",
          country_id: dataVal?.country_id || "",
          state_id: dataVal?.state_id || "",
          city_id: dataVal?.city_id || "",
          date_of_birth: dataVal?.date_of_birth !== null ? dayjs(dataVal?.date_of_birth) : null,
          full_address_1: dataVal?.full_address_1 || "",
          zip_code: dataVal?.zip_code,
        };

        setPersonalInputData((prevState) => {
          return {
            ...prevState,
            ...newObj,
          };
        });
        form.setFieldsValue(newObj);
      } else {
        setUserName([]);
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.log(error, "api error");
    }
  };
  const fetchUserUpdateDetails = async (value) => {

    setShowNotification(true);

    const formdata = new URLSearchParams();
    formdata.append("update_user_id", id);
    formdata.append("firstname", value?.firstname);
    formdata.append("lastname", value?.lastname);
    formdata.append("contactnumber", value?.contactnumber);
    formdata.append("role_id", 0);
    formdata.append("company_id", 0);
    formdata.append("department_id", 0);
    formdata.append("designation_id", 0);
    formdata.append("module_id", value?.module);
    formdata.append("jobgrade_id", 0);
    formdata.append("reporting_mngr_id", 0);
    formdata.append("business_unit_id", 0);
    formdata.append("email", value?.email);
    formdata.append("country_id", value?.country_id);
    formdata.append("state_id", value?.state_id);
    formdata.append("city_id", value?.city_id);
    formdata.append("full_address_1", value?.full_address_1);
    formdata.append("zip_code", value?.zip_code);
    formdata.append(
      "date_of_birth",
      value?.date_of_birth !== null ? dayjs(value?.date_of_birth)?.format("YYYY-MM-DD") : ""
    );

    try {
      const response = await request("/user-details-update", "put", formdata, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        BdUserdetails();
        handleReset();
        notifySuccess(response?.data?.message);
      } else {
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.log(error, "Api Error");
    }
  };

  const getAddTenderCountry = async () => {
    try {
      const response = await request("/country-list", "get");

      if (response?.data?.status === "1") {
        setProfileCountry(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };

  const getAddTenderState = async () => {
    const formData = new URLSearchParams();
    formData.append("country_id", personalInputData?.country_id);
    try {
      // const response = await AddTenderList.getTenderStateList(formData)
      const response = await request("/state-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setProfileState(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };
  const getAddTenderCity = async () => {
    const formData = new URLSearchParams();
    formData.append("state_id", personalInputData?.state_id);
    try {
      // const response = await AddTenderList.getTenderCityList(formData)
      const response = await request("/city-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setProfileCity(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };

  useEffect(() => {
    getAddTenderState();
  }, [personalInputData?.country_id]);

  useEffect(() => {
    getAddTenderCity();
  }, [personalInputData?.state_id]);

  const handleReset = () => {
    setPersonalInputData("");
    form?.resetFields();
  };
  const handleInputChange = (name, value) => {
    setPersonalInputData({
      ...personalInputData,
      [name]: value,
    });
  };
  const location = useLocation();
  const val = location?.pathname;
  const str = val.replace("/", "");
  useEffect(() => {
    setSkeleton(true);
    const timer = setTimeout(() => setSkeleton(false), 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [form?.length]);

  // passord api --- khushbu
  const postPasswordChange = async (handleResetChangePassword, isAdmin) => {
    const { password, confirmPassword, old_password } = personalInputData;

    try {
      const formData = new URLSearchParams();
      formData.append("user_id", id);

      if (!isAdmin) formData.append("old_password", old_password);

      if (!isAdmin) {
        const response = await request("/check-user-old-password", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });
        if (response.data.status !== "1") return notify("Old Password is incorrect!!");
      }

      if (password === confirmPassword) {
        const formData = new URLSearchParams();
        formData.append("user_id", id);
        formData.append("password", password);

        const response = await request("/user-change-password", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });

        if (response.data.status === "1") {
          setPersonalInputData(response?.data?.message);
          notifySuccess(response?.data?.message);
          handleReset();
          handleResetChangePassword();
        } else {
          notify(response?.response?.data?.message);
        }
      } else {
        notify("Passwords do not match or do not meet criteria");
      }
    } catch (error) {
      console.log(error);
      console.log("Server error");
    }
  };

  useEffect(() => {
    BdUserdetails();
    getAddTenderCountry();
  }, []);

  const handleProfileChange = (name, e) => {
    const trimmedValue = e.target.value.trimStart(); // Trim leading spaces
    form.setFieldsValue({ [name]: trimmedValue }); //
  };

  const disableFutureDates = (current) => {
    // Disable all dates after today
    return current && current > moment().endOf("day");
  };

  const { userInfo } = useSelector((state) => state.userDetails);

  function handleImageChange(event) {
    const file = event.target.files[0];
    updateProfilePicture(file);
  }

  const updateProfilePicture = async (file) => {
    const formData = new FormData();
    formData.append("user_id", id);
    formData.append("files", file);
    try {
      // const response = await userDetailsApi.updateUserProfilePic(formData);
      const response = await request("/user-profile-pic-update", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        BdUserdetails();
        notifySuccess("Logo updated successfully");
      } else {
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      notify("Error updating logo");
    }
  };

  const validateContactNumber = (_, value) => {
    const regex = /^\d{10}$/;

    if (!value || regex.test(value)) {
      return Promise.resolve();
    }

    return Promise.reject("Contact number must be a 10-digit number");
  };
  const validateZipCode = (_, value) => {
    if (value && value.length > 6) {
      return Promise.reject("Zip code must not exceed 6 characters");
    }
    return Promise.resolve();
  };

  const getModule = async () => {
    try {
      const response = await request("/module-list", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setModule(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getModule();
  }, []);
  console.log(personalInputData.module   ,typeof personalInputData.module)

  return (
    <>
      <>
        {/* <Breadcrumb data={str} /> */}
        <Header />
        <div className="bd_profile_main">
          <div className="bd_main_profile_headings">
            <h2 style={{ margin: "20px" }}>User Profile</h2>
            <div className="bd_main_add">
              <div className="bd_main_sub_add_profile">
                <div className="bd_main_sub_image">
                  {/* <img alt='' className="img-thumbnail rounded-circle"
              src={`https://doc.kairaus.com/${userName.profileimg_path}/${userName.profileimg}`}
              /> */}
                  {userName?.profileimg ? (
                    <img
                      alt=""
                      className="img-thumbnail rounded-circle"
                      src={
                        userName?.profileimg !== null
                          ? `${DocImgBaseUrl}${userName.profileimg_path}/${userName.profileimg}`
                          : DefaultImage
                      }
                    />
                  ) : (
                    // <Avatar style={{ width: "40px", height: "40px" }}>
                    //   {userName?.firstname !== null
                    //     ? userName?.firstname?.charAt(0)
                    //     : userName?.userfullname?.charAt(0)}
                    // </Avatar>
                    <div
                      style={{
                        background: "#000",
                        color: "white",
                        borderRadius: "50%",
                        aspectRatio: "1/1",
                        overflow: "hidden",
                        padding: "1rem",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="150px"
                        height="150px"
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </div>
                  )}

                  <label className="bd_main_update_profile_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path
                        fillRule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                      />
                    </svg>
                    <input className="input_update_file" type="file" accept="image/*" onChange={handleImageChange} />
                  </label>

                  {/* <button onClick={updateProfile}>Update Profile</button> */}
                </div>
                {/* <div className="line_through"></div> */}
                <div className="bd_main_sub_info">
                  {skeleton ? (
                    <>
                      <div className="sub_emp_id">
                        <Skeleton variant="rectangular" width={120} height={25} />
                        <Skeleton variant="rectangular" width={100} height={25} />
                      </div>
                      <div className="sub_contact">
                        <p className="sub_pera">
                          {" "}
                          <span className="sub_span">Email:</span>
                          <Skeleton variant="rectangular" width={200} height={23} />
                        </p>
                        <p className="sub_pera">
                          {" "}
                          <span className="sub_span">Contact:</span>
                          <Skeleton variant="rectangular" width={200} height={23} />
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="sub_emp_id">
                        <span className="sub_emp_head">{userName.userfullname}</span>
                        <span className="sub_id">{personalInputData?.role?.map((item) => item?.role_name)}</span>
                      </div>
                      <div className="sub_contact">
                        <p className="sub_pera">
                          {" "}
                          <span className="sub_span">Email:</span> {userName?.email}
                        </p>
                        <p className="sub_pera">
                          {" "}
                          <span className="sub_span">Contact:</span>
                          {userName?.contactnumber}{" "}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <--------- tabs -------> */}
          <div className="bd_main_profile_tabs">
            <div className="profile_tabs_heading">
              <Tabs
                defaultActiveKey="1"
                items={[
                  {
                    label: "Official",
                    key: "1",
                    children: (
                      <div className="profile_detail_info_box">
                        <div className="profile_sub_info">
                          <Form
                            form={form}
                            name="control-hooks"
                            layout="vertical"
                            autoComplete="off"
                            onFinish={fetchUserUpdateDetails}
                            // initialValues={{ module: personalInputData?.module_id }}
                          >
                            <Row gutter={20}>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="First Name:"
                                  name="firstname"
                                  rules={[
                                    {
                                      required: true,
                                      message: "First name is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter here"
                                    disabled={isIdpMode}
                                    onChange={(e) => handleProfileChange("firstname", e)}
                                  />
                                </Form.Item>
                              </Col>

                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Last Name:"
                                  name="lastname"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Last name is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter here"
                                    disabled={isIdpMode}
                                    onChange={(e) => handleProfileChange("lastname", e)}
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Email:"
                                  name="email"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Email is required",
                                    },
                                    {
                                      type: "email",
                                      message: "Please enter a valid email address",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter here"
                                    disabled={isIdpMode}
                                    onChange={(e) => handleProfileChange("email", e)}
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Contact Number:"
                                  name="contactnumber"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Contact Number is required",
                                    },
                                    { validator: validateContactNumber },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter here"
                                    type="number"
                                    disabled={isIdpMode}
                                    onChange={(e) => handleProfileChange("contactnumber", e)}
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="DOB:"
                                  name="date_of_birth"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Date of birth is required",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    name="date_of_birth"
                                    placeholder="Select Date"
                                    value={
                                      personalInputData?.date_of_birth ? moment(personalInputData.date_of_birth) : null
                                    }
                                    onChange={(value) => handleInputChange("date_of_birth", value)}
                                    disabledDate={disableFutureDates}
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Country:"
                                  name="country_id"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Country is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    value={personalInputData?.country_id}
                                    onChange={(value) => handleInputChange("country_id", value)}
                                    name="country_id"
                                    placeholder="Select Country"
                                    options={profileCountry?.map((item, index) => {
                                      return {
                                        value: item?.id,
                                        label: item?.country_name,
                                      };
                                    })}
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="State:"
                                  name="state_id"
                                  rules={[
                                    {
                                      required: true,
                                      message: "State is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    value={personalInputData.state_id}
                                    onChange={(value) => handleInputChange("state_id", value)}
                                    options={profileState?.map((item, index) => {
                                      return {
                                        value: item?.id,
                                        label: item?.state_name,
                                      };
                                    })}
                                    placeholder="Select State"
                                    name="state_id"
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  ></Select>
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="City:"
                                  name="city_id"
                                  rules={[
                                    {
                                      required: true,
                                      message: "City is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    value={personalInputData.city_id}
                                    onChange={(value) => handleInputChange("city_id", value)}
                                    options={profileCity?.map((item, index) => {
                                      return {
                                        value: item?.id,
                                        label: item?.city_name,
                                      };
                                    })}
                                    name="city_id"
                                    placeholder="Select City"
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Zip Code:"
                                  name="zip_code"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Zip code is required",
                                    },
                                    {
                                      validator: validateZipCode,
                                    },
                                  ]}
                                >
                                  <Input placeholder="Enter here" type="number" />
                                </Form.Item>
                              </Col>

                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Full Address:"
                                  name="full_address_1"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Full address is required",
                                    },
                                  ]}
                                >
                                  <TextArea
                                    name="full_address_1"
                                    placeholder="Enter here"
                                    value={personalInputData?.full_address_1}
                                    onChange={(e) => handleInputChange("full_address_1", e?.target?.value)}
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Module"
                                  name="module"
                                  rules={[{ required: true, message: "module is required" }]}
                                >
                                  <Select
                                    mode="multiple"
                                    showSearch
                                    onChange={(value) => handleInputChange("module_id", value)}
                                value={personalInputData.module}
                                    options={module?.map((item, index) => {
                                      return {
                                        value:item?.id,
                                        label: item?.folder_name,
                                      };
                                    })}
                                    placeholder="Select Module"
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <div className="profile_button_sec">
                              <Button className="BG_ghostButton" onClick={handleReset}>
                                Reset
                              </Button>
                              {/* <Button className='BG_mainBtton'>Save & Change</Button> */}
                              <Button className="BG_mainButton" key="submitt" htmlType="submit">
                                Save & Change
                              </Button>
                            </div>
                          </Form>
                        </div>
                      </div>
                    ),
                  },

                  !isIdpMode && {
                    label: "Change Password",
                    key: "3",
                    children: (
                      <PasswordChange
                        form="passwordForm"
                        personalInputData={personalInputData}
                        handleInputChange={handleInputChange}
                        handleReset={handleReset}
                        postPasswordChange={postPasswordChange}
                        setPersonalInputData={setPersonalInputData}
                        isAdmin={true}
                      />
                    ),
                  },
                ].filter(Boolean)}
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default EMPLOYEEUpdateProfile;
